import React from "react";
import styled from "styled-components";

export default class ContentEditable extends React.Component {
  constructor() {
    super();
    this.emitChange = this.emitChange.bind(this);
    this.keyPress = this.keyPress.bind(this);
  }

  render() {
    var { tagName, html, ...props } = this.props;

    return React.createElement(tagName || "div", {
      ...props,
      ref: e => (this.htmlEl = e),
      onFocus: this.props.onFocus,
      onInput: this.emitChange,
      onKeyPress: this.keyPress,
      onBlur: this.props.onBlur || this.emitChange,
      contentEditable: !this.props.disabled,
      dangerouslySetInnerHTML: { __html: html }
    });
  }

  shouldComponentUpdate(nextProps) {
    let { props, htmlEl } = this;

    // We need not rerender if the change of props simply reflects the user's edits.
    // Rerendering in this case would make the cursor/caret jump

    // Rerender if there is no element yet... (somehow?)
    if (!htmlEl) {
      return true;
    }

    // ...or if html really changed... (programmatically, not by user edit)
    if (nextProps.html !== htmlEl.innerHTML && nextProps.html !== props.html) {
      return true;
    }

    let optional = ["style", "className", "disable", "tagName"];

    // Handle additional properties
    return optional.some(name => props[name] !== nextProps[name]);
  }

  componentDidUpdate() {
    if (this.htmlEl && this.props.html !== this.htmlEl.innerHTML) {
      // Perhaps React (whose VDOM gets outdated because we often prevent
      // rerendering) did not update the DOM. So we update it manually now.
      this.htmlEl.innerHTML = this.props.html;
    }
  }

  emitChange(evt) {
    if (!this.htmlEl) return;
    var html = this.htmlEl.innerHTML;
    if (this.props.onChange && html !== this.lastHtml) {
      evt.target = { value: html };
      this.props.onChange(evt);
    }
    this.lastHtml = html;
  }

  keyPress(evt) {
    if (this.props.onKeyPress) {
      this.props.onKeyPress(evt);
    }
  }
}

export const TextWrapper = styled.div`
  position: relative;
  margin: 0;
  margin-bottom: 0rem;

  :before {
    position: absolute;
    top: 1rem;
    left: 0rem;
    content: ${props =>
      props.showPlaceholder ? "attr(data-placeholder)" : "none"};
    pointer-events: none;

    font-size: 1.5rem;
    line-height: 1.33;
    color: ${props =>
      props.placeholderColor ? props.placeholderColor : "#767676"};

    @media only screen and (min-width: 62rem) {
      left: 1.5rem;
      font-size: 2rem;
    }
  }

  :focus {
    :before {
      content: none;
    }
  }

  border: 0px solid #ebebeb;
  cursor: text;
`;

export const Textarea = styled(ContentEditable)`
  overflow: hidden;
  overflow-y: auto;

  height: 12rem;

  padding-top: 1rem;
  padding-left: 0rem;
  padding-right: 0rem;
  padding-bottom: 1rem;

  tab-size: 4;
  white-space: pre-wrap;
  word-wrap: break-word;

  font-size: 1.5rem;
  line-height: 1.33;
  color: #111111;

  outline: none;

  @media only screen and (min-width: 62rem) {
    height: 25rem;
    font-size: 2rem;

    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
`;



// WEBPACK FOOTER //
// ./src/ui/ContentEditable.js